import { CardSize } from '@repo/types';

/**
 * Maps a {@link CardSize} to its BEM `--size-*` modifier class for the given
 * block, or `undefined` for `auto`/unset (which keeps the card's fit-to-container
 * default, i.e. no modifier). `block` is the BEM block name, e.g.
 * `article-card` → `article-card--size-large`.
 */
export const cardSizeClass = (block: string, size?: CardSize): string | undefined =>
  size && size !== 'auto' ? `${block}--size-${size}` : undefined;
